import React from 'react'
import Page from '../../layout/Page'
import { Tab } from 'semantic-ui-react'
import NewPerformanceEvaluationPage from './NewPerformanceEvaluationPage'
import PerformanceEvaluationPage from './PerformanceEvaluationPage'

const PerformanceEvaluationMenuPage = () => {

    const MENU_ITEMS = [
        { menuItem: 'HR Performance Evaluation', render: () => <PerformanceEvaluationPage /> },
        { menuItem: 'Accounts Performance Evaluation', render: () => <NewPerformanceEvaluationPage/>}
    ]

    return (
        <Page>
            <Tab
                menu={{ secondary: true, pointing: true }}
                panes={MENU_ITEMS} />
        </Page>
    )
}

export default PerformanceEvaluationMenuPage